import React from "react";
import { useStore } from "../store";
import Section from "../components/section/section";
import HexagonButton from "../components/hexagon-button/hexagon-button";
import Hexagon1 from "../components/hexagon-1";
import Hexagon2 from "../components/hexagon-2";
import Hexagon3 from "../components/hexagon-3";

export default function EndFrame50() {
  const { section, setSection, showEndFrame } = useStore();
  const watchedSections = React.useMemo(() => {
    return (
      JSON.parse(window.localStorage.getItem(`kasperskey.watchedSections`)) ??
      []
    );
  }, [section]);

  if (section !== 5.0 || !showEndFrame) return null;

  return (
    <Section name="5-0">
      <HexagonButton
        onClick={() => setSection(5.1)}
        disabled={watchedSections.includes(5.1)}
      >
        <div>Get a head-start</div>
        <Hexagon1 />
      </HexagonButton>
      <HexagonButton
        onClick={() => setSection(5.2)}
        disabled={watchedSections.includes(5.2)}
      >
        <div>
          Develop your
          <br /> side hustle
        </div>
        <Hexagon2 />
      </HexagonButton>
      <HexagonButton
        onClick={() => setSection(5.3)}
        disabled={watchedSections.includes(5.3)}
      >
        <div>Have some fun!</div>
        <Hexagon3 />
      </HexagonButton>
    </Section>
  );
}
